export default {
  subtitle: 'Enviamos los eventos seleccionados a tus endpoints mediante POST, firmados con el secreto del endpoint.',
  regenerate_confirm: '¿Generar un nuevo secreto de firma? El secreto actual dejará de funcionar de inmediato.',
  delete_confirm: '¿Eliminar este endpoint? Dejará de recibir eventos.',
  consecutive_failures: '{{count}} fallos consecutivos',
  columns: {
    url: 'Endpoint',
    events: 'Eventos',
    status: 'Estado',
    secret: 'Secreto',
  },
  statuses: {
    active: 'Activo',
    disabled: 'Deshabilitado',
    auto_disabled: 'Deshabilitado automáticamente',
  },
  buttons: {
    create: 'Añadir endpoint',
    edit: 'Editar',
    regenerate_secret: 'Nuevo secreto',
    delete: 'Eliminar',
  },
  toasts: {
    load_error: 'No se pudieron cargar los endpoints de webhook.',
    error: 'Algo salió mal. Inténtalo de nuevo.',
    deleted: 'Endpoint eliminado.',
  },
};
